import React from 'react';
import { Message, Role } from 'lecture_pages/components/ai-role-play/ai-conversation-modal/context';
import AiChat from 'lecture_pages/components/ai-role-play/ai-conversation-modal/ai-chat';
import LearnerChat from 'lecture_pages/components/ai-role-play/ai-conversation-modal/learner-chat';

type ConversationReplayProps = {
  messages: Message[];
  openingNarrative: string;
};

const ConversationReplay = ({ messages, openingNarrative }: ConversationReplayProps) => (
  <div className='d-flex flex-column'>
    {openingNarrative && (
      <div className='w-100 mt-5'>
        {openingNarrative}
      </div>
    )}
    {messages.map((message) => (
      message.role === Role.AI ? (
        <div key={message.id} className='w-100 mt-5'>
          <AiChat content={message.content} />
        </div>
      ) : (
        <div key={message.id} className='w-100 mt-5'>
          <LearnerChat content={message.content} />
        </div>
      )
    ))}
  </div>
);

export default ConversationReplay;
